export default __webpack_public_path__ + "static/media/others-benefit.78cb0c97.svg";